import { Component, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { BackgroundLocationService } from "src/app/_services/background-location.service";

export type PermissionDetailKey = "location" | "battery" | "autostart" | "displayPopups";

@Component({
  selector: "app-permission-detail",
  templateUrl: "./permission-detail.component.html",
  styleUrls: ["./permission-detail.component.scss"],
})
export class PermissionDetailComponent implements OnInit {
  @Input() permissionKey!: PermissionDetailKey;

  title = "";
  fullDescription = "";
  icon = "";
  accessSettingsLabel = "";

  constructor(
    private modalCtrl: ModalController,
    private translate: TranslateService,
    private backgroundLocation: BackgroundLocationService
  ) {}

  ngOnInit(): void {
    const key = this.permissionKey;
    const titleKey =
      key === "location"
        ? "PERMISSIONS.STEPPER.LOCATION_TITLE"
        : key === "battery"
          ? "PERMISSIONS.STEPPER.BATTERY_TITLE"
          : key === "autostart"
            ? "PERMISSIONS.AUTOSTART_TITLE"
            : "PERMISSIONS.DISPLAY_POPUPS_TITLE";

    const descKey =
      key === "location"
        ? "PERMISSIONS.STEPPER.LOCATION_DESCRIPTION"
        : key === "battery"
          ? "PERMISSIONS.STEPPER.BATTERY_DESCRIPTION"
          : key === "autostart"
            ? "PERMISSIONS.AUTOSTART_DESCRIPTION"
            : "PERMISSIONS.DISPLAY_POPUPS_DESCRIPTION";
    const iconMap: Record<PermissionDetailKey, string> = {
      location: "navigate",
      battery: "battery-charging",
      autostart: "flash",
      displayPopups: "notifications-outline",
    };
    this.title = this.translate.instant(titleKey);
    this.fullDescription = this.translate.instant(descKey);
    this.icon = iconMap[key] || "information-circle";
    this.accessSettingsLabel = this.translate.instant("PERMISSIONS.ACCESS_SETTINGS");
  }

  async openSettings(): Promise<void> {
    try {
      if (this.permissionKey === "location") {
        await this.backgroundLocation.openAppLocationSettings();
      } else if (this.permissionKey === "battery") {
        await this.backgroundLocation.requestBatteryOptimizationDisable();
      } else if (this.permissionKey === "autostart") {
        await this.backgroundLocation.openPermissionGuide("Demarrage automatique constructeur");
      } else if (this.permissionKey === "displayPopups") {
        await this.backgroundLocation.openPermissionGuide("Afficher les fenêtres contextuelles");
      } else {
        await this.backgroundLocation.openAppLocationSettings();
      }
    } catch (e) {
      console.error("[PermissionDetail] openSettings failed", e);
    }
  }

  close(): void {
    this.modalCtrl.dismiss();
  }
}
